const fullfillImpressionsDataLayer = (impressions) => {
  if (window && !window.dataLayer) {
    return;
  }

  const { dataLayer } = window;

  const payload = {
    event: 'ee_offer_impr',
    ecommerce: {
      impressions
    }
  };

  dataLayer.push(payload);
};

const fullfillClicksDataLayer = (list, clickData) => {
  if (window && !window.dataLayer) {
    return;
  }
  const { dataLayer } = window;

  const payload = {
    event: 'ee_offer_click',
    ecommerce: {
      click: {
        actionField: { list },
        products: [
          clickData
        ]
      }
    }
  };

  dataLayer.push(payload);
};


export { fullfillImpressionsDataLayer, fullfillClicksDataLayer };
